module.exports = __webpack_public_path__ + "img/kehu_changchengkuandai.fd79387f.png";